import React from 'react';
import styles from './Navigations.module.scss'
import { NavLink} from "react-router-dom";



const Navigation = (props) => {


    return (
            <div className={styles.navigation}>
                            <NavLink activeClassName={styles.active}  exact to="/">Home</NavLink>
                            <NavLink activeClassName={styles.active}  to='/portfolio'>Портфолио</NavLink>
                            <NavLink  activeClassName={styles.active}  to='/skills'><span className='red'>Навыки</span></NavLink>
                            <NavLink activeClassName={styles.active}  to='/contacts'>Контакты</NavLink>
            </div>

    );
};

export default Navigation;